import React from 'react'

import { useSelector } from 'react-redux'

import { selectLeaguesProductTypes } from '../../reducers/leagues_filter_values'

const LeaguesBrowserLegend = () => {
  const productTypes = useSelector(selectLeaguesProductTypes)

  return <span className='cls-lb-legend-container'>
    {Object.entries(productTypes).filter(([ leagueType, _ ]) => leagueType !== 'all')
      .map(([ leagueType, _ ]) => {
      return (
        <span key={`legend-item-${leagueType}`} className='cls-lb-legend-entry'>
          <span className={`circle-${leagueType}`} />
          <span>
            {window.I18n.t(`${leagueType}_name`)}
          </span>
        </span>)
    })}
  </span>
}


export default LeaguesBrowserLegend
